export default __webpack_public_path__ + "static/media/guru.bd30da42.avif";